import classNames from 'classnames'
import css from './author_profile.scss'
import { Box, Grid } from '@material-ui/core'

const Experience = ({ author }) => {
  if (
    author.jobTitle ||
    author.yearsOfExperience ||
    author.responsibilities?.length ||
    author.areasOfExpertise?.length ||
    author.specialties?.length ||
    author.featuredIn?.length
  ) {
    return (
      <Box
        className={classNames(
          css.authorProfileExperience,
          css.authorProfileSection
        )}
      >
        <h2>Experience</h2>
        <p>
          <strong>{author.jobTitle}</strong>
        </p>
        <Grid container spacing={2}>
          {author.yearsOfExperience > 0 && (
            <>
              <Grid item xs={6}>
                <strong>Years of Experience:</strong>
              </Grid>
              <Grid item xs={6}>
                {author.yearsOfExperience}
              </Grid>
            </>
          )}
          {author.responsibilities && author.responsibilities.length > 0 && (
            <>
              <Grid item xs={6}>
                <strong>Responsibilities:</strong>
              </Grid>
              <Grid item xs={6}>
                {author.responsibilities.join(', ')}
              </Grid>
            </>
          )}
          {author.areasOfExpertise && author.areasOfExpertise.length > 0 && (
            <>
              <Grid item xs={6}>
                <strong>Skills:</strong>
              </Grid>
              <Grid item xs={6}>
                {author.areasOfExpertise.join(', ')}
              </Grid>
            </>
          )}
          {author.specialties && author.specialties.length > 0 && (
            <>
              <Grid item xs={6}>
                <strong>Specialties:</strong>
              </Grid>
              <Grid item xs={6}>
                {author.specialties.join(', ')}
              </Grid>
            </>
          )}
          {author.featuredIn && author.featuredIn.length > 0 && (
            <>
              <Grid item xs={6}>
                <strong>Featured In:</strong>
              </Grid>
              <Grid item xs={6}>
                {author.featuredIn
                  ?.map((featuredIn, i) => featuredIn.title)
                  ?.join(', ')}
              </Grid>
            </>
          )}
        </Grid>
      </Box>
    )
  } else {
    return null
  }
}

export default Experience
